module.exports = __webpack_public_path__ + "static/img/terms-and-conditions.550899f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/terms-and-conditions.png
// module id = /jWd
// module chunks = 1